import { Flex } from '.';
import { theme } from '../../design-system';
import { LocalVideo, RemoteVideo } from '.';
import { useEffect, useState } from 'react';

const VideoChatScreen = ({ show }) => {
  const [smallScreen, setSmallScreen] = useState(false);

  useEffect(() => {
    const smallScreenQuery = window.matchMedia('(max-width: 400px)');

    const checkMatch = () => {
      return smallScreenQuery.matches ? setSmallScreen(true) : setSmallScreen(false);
    };

    checkMatch();
    smallScreenQuery.addEventListener('change', checkMatch);
    return () => smallScreenQuery.removeEventListener('change', checkMatch);
  }, []);

  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      column={smallScreen}
      height={show ? '100vh' : '0'}
      width={show ? '100vw' : '0'}
      position='fixed'
      top='55px'
      backgroundColor='white'
      left='0'
      zIndex='100'
      transition='height 500ms ease-out'
      overflow='scroll'
    >
      <Flex
        justifyContent='center'
        width={smallScreen ? '60%' : '40%'}
        height={smallScreen ? '40%' : '60%'}
        maxHeight='200px'
        maxWidth='200px'
        style={{ objectFit: 'cover', boxShadow: theme.elevations.elevation4, borderRadius: '4px' }}
        {...(!smallScreen && { marginRight: '2rem' })}
        {...(smallScreen && { marginBottom: '1rem' })}
      >
        <LocalVideo controls />
      </Flex>
      <Flex
        justifyContent='center'
        width={smallScreen ? '60%' : '40%'}
        height={smallScreen ? '40%' : '60%'}
        maxHeight='200px'
        maxWidth='200px'
        style={{ objectFit: 'cover', boxShadow: theme.elevations.elevation4, borderRadius: '4px' }}
      >
        <RemoteVideo />
      </Flex>
    </Flex>
  );
};

export default VideoChatScreen;
